import { environment } from '../environments/environment';

const _VERSION = '6.10.3';
const _VERSIONDATE = '11.07.2025';
const _DEBUG_INFO_ENABLED = !environment.production;
const _API_SERVER = (environment.training) ? environment.api_server_training : environment.api_server;
const _API_SERVER_VERSION = environment.api_server_version;
const _TRAINING = environment.training;
const _MERCHANT_WEBAPP_URL = environment.merchant_webapp;
const _PIMCORE = environment.pimcore;
const _MERCHANT_WEBAPP_PASSWORD = environment.merchant_webapp_password;
const _MERCHANT_WEBAPP_USER = environment.merchant_webapp_user;

export const VERSION = _VERSION;
export const VERSIONDATE = _VERSIONDATE;
export const DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;
export const API_SERVER = _API_SERVER;
export const API_SERVER_VERSION = _API_SERVER_VERSION;
export const TRAINING = _TRAINING;
export const NEW_IMAGE_UPLOAD = true;
export const MERCHANT_WEBAPP_URL = _MERCHANT_WEBAPP_URL;
export const PIMCORE = _PIMCORE;

export const MERCHANT_WEBAPP_PASSWORD = _MERCHANT_WEBAPP_PASSWORD;
export const MERCHANT_WEBAPP_USER = _MERCHANT_WEBAPP_USER;

export const PLAUSIBLE_ENERGY_CONSUMPTION_SU = {
  halfDay: {
    low: 10,
    high: 40
  },
  fullDay: {
    low: 20,
    high: 80
  }
};

export const PLAUSIBLE_ENERGY_CONSUMPTION_SQM = {
  halfDay: {
    low: 0.5,
    high: 2
  },
  fullDay: {
    low: 1,
    high: 4
  }
};

export const CUSTOM_SLUG = {'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'Ä': 'AE', 'Ö': 'OE', 'Ü': 'UE', 'ß': 'ss', '/': '-', '.': '-'};



// WEBPACK FOOTER //
// ./src/app/app.constants.ts